import { render, staticRenderFns } from "./InspectPage.vue?vue&type=template&id=35aad605&scoped=true&"
import script from "./InspectPage.vue?vue&type=script&lang=js&"
export * from "./InspectPage.vue?vue&type=script&lang=js&"
import style0 from "./InspectPage.vue?vue&type=style&index=0&id=35aad605&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35aad605",
  null
  
)

export default component.exports